import { DatePicker, Form, Input } from "antd";
import { useEffect } from "react";

const ReferenceDataForm = ({ form, data }) => {
  
    useEffect(() => {
      form.setFieldsValue(data || {});
    }, [data]);
  
 
    return (
      <Form form={form} layout="vertical">
        <Form.Item name="code" label="Code" rules={[{ required: true }]}><Input /></Form.Item>
        <Form.Item name="name" label="Description" rules={[{ required: true }]}><Input /></Form.Item>
        <Form.Item name="startDate" label="Valid From"><DatePicker /></Form.Item>
        <Form.Item name="endDate" label="Valid Until"><DatePicker /></Form.Item>
      </Form>
    );
  };

  export { ReferenceDataForm };
  